import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { employerJobCreationStepsSingle } from '../../../../constants/jobs';
import ItemIconsList from './ItemIconsList';
import VerifiedCheckIn from '../VerifiedCheckIn';

export default class DressCodeDescriptionStep extends Component {
  static propTypes = {
    dressCodesList: PropTypes.array.isRequired,
    dressCodeId: PropTypes.number.isRequired,
    dressCode: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    whereToReport: PropTypes.string.isRequired,
    handleChangeDressCode: PropTypes.func.isRequired,
    isThirdStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired
  };

  render () {
    const { goToStep, isThirdStepFilled, dressCodesList, dressCodeId, handleChangeDressCode, dressCode, description,
      handleChangeTextInput, whereToReport, checkin_verification_required, handleSwitch, company } = this.props;
    return (
      <React.Fragment>
        <VerifiedCheckIn
          onChange={() => handleSwitch('checkin_verification_required')}
          isChecked={checkin_verification_required}
          company={company}
        />

        <section className='job-posting-section'>
          <header><h4>Choose The Dress Code</h4></header>
          <ItemIconsList
            listData={dressCodesList}
            selectedItemId={dressCodeId}
            chooseItemHandler={handleChangeDressCode}
            iconSourceFieldName='image_url'
            labelFieldName='description_en'
          />
          <h5 className='separated additional-instructions'><label className='sub-header' htmlFor='dress-code-textarea'>
            Fill out additional dress code instructions:
          </label></h5>
          <textarea
            id='dress-code-textarea'
            className='styled-textarea'
            name='dress_code'
            placeholder='Write dress code requirements...'
            value={dressCode || ''}
            onChange={handleChangeTextInput}
          />
        </section>
        <section className='job-posting-section'>
          <header><h4>Enter Job Description and Instructions</h4></header>
          <h5><label className='sub-header' htmlFor='description-textarea'>
            Description:
          </label></h5>
          <textarea
            id='description-textarea'
            className='styled-textarea'
            name='description'
            placeholder='Type description here...'
            value={description || ''}
            onChange={handleChangeTextInput}
          />
          <h5 className='separated additional-instructions'>
            <label className='sub-header' htmlFor='additional-instructions-textarea'>
              Additional Instructions:
            </label>
          </h5>
          <textarea
            id='additional-instructions-textarea'
            className='styled-textarea'
            name='where_to_report'
            placeholder='Enter instructions on where to report, parking, security, etc.'
            value={whereToReport || ''}
            onChange={handleChangeTextInput}
          />
        </section>
        <div className='nav-buttons-wrapper'>
          <button
            className='gravy-button back-step-button'
            onClick={() => goToStep(employerJobCreationStepsSingle.second.id)}
          >Back</button>
          { isThirdStepFilled() && (
            <button
              className='gravy-button info-btn'
              onClick={() => goToStep(employerJobCreationStepsSingle.summary.id)}
            >Next</button>
          )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJobEmployerSingle/DressCodeDescriptionStep.js